<script lang="ts">
	import type { MarkdownOptions } from '@magidoc/plugin-svelte-marked';
	import type { Renderers } from '@magidoc/plugin-svelte-marked';
	import { BaseBlockquote, type BaseBlockquoteProps } from '../BaseBlockquote';

	interface Props {
		token: BaseBlockquoteProps['token'];
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { token, options, renderers }: Props = $props();
</script>

<BaseBlockquote
	{token}
	{options}
	{renderers}
	variant="body3"
	boldVariant="label4"
	class="text-gray-500"
/>
